import useGenerateImageUploadUrls from '@/hooks/useGenerateImageUploadUrls';
import useUploadImage from '@/hooks/useUploadImage';
import type { EntityListField } from './EntityList.types';

type UseUploadEntityAvatarsUploadArgs = {
  name: string;
  entities: EntityListField[];
};

export function useUploadEntityAvatars(name: string) {
  const generateImageUploadUrls = useGenerateImageUploadUrls();
  const uploadImage = useUploadImage();

  const upload = async (
    entities: UseUploadEntityAvatarsUploadArgs['entities'],
  ) => {
    const entityMap: { [key: string]: string } = {};
    const { data: uploadUrls } = await generateImageUploadUrls(entities.length);

    if (uploadUrls?.generateImageUploadUrls?.length !== entities.length) {
      throw new Error("Couldn't Upload Avatar Images");
    }

    const avatarUploadPromises = entities.map((entity, index) => {
      const uploadUrlData = uploadUrls.generateImageUploadUrls?.[index];

      if (entity.id && uploadUrlData?.id) {
        entityMap[entity.id] = uploadUrlData.id;
      }

      return uploadImage(
        `${name}/${entity.id}/profile`,
        entity.localAvatarUrl || '',
        uploadUrlData?.uploadURL || '',
      );
    });

    const avatarUploadResults = await Promise.allSettled(avatarUploadPromises);

    const didSomeReject = avatarUploadResults.some(
      (result) => result.status === 'rejected',
    );

    if (didSomeReject) {
      throw new Error("Couldn't Upload Avatar Images");
    }

    return entityMap;
  };

  return { upload };
}
